import Head from 'next/head'
import React from 'react'
import Modal from 'react-modal'

import Apartment from '../assets/videos/apartment.svg'
import BankAccount from '../assets/videos/bankaccounts.svg'
import CarInsurance from '../assets/videos/carins.svg'
import Cars from '../assets/videos/cars.svg'
import CreditCard from '../assets/videos/creditcard.svg'
import Debt from '../assets/videos/debt.svg'
import Education from '../assets/videos/education.svg'
import EstatePlan from '../assets/videos/estateplan.svg'
import HealthInsurance from '../assets/videos/healthins.svg'
import HomeInsurance from '../assets/videos/homeins.svg'
import Homes from '../assets/videos/homes.svg'
import Houses from '../assets/videos/houses.svg'
import IdTheft from '../assets/videos/idtheft.svg'
import Insurance from '../assets/videos/insurance.svg'
import Investing from '../assets/videos/investing.svg'
import LifeInsurance from '../assets/videos/lifeins.svg'
import Loans from '../assets/videos/loans.svg'
import LtdInsurance from '../assets/videos/ltdins.svg'
import Relationships from '../assets/videos/relationships.svg'
import RentersInsurance from '../assets/videos/renterins.svg'
import Retirement from '../assets/videos/retirement.svg'
import SpendingPlans from '../assets/videos/spendingplan.svg'
import Taxes from '../assets/videos/taxes.svg'
import { Layout } from '../components/Layout'
import { customStyles } from '../components/Modal'

const Videos = () => {
  const [insuranceModalOpen, setInsuranceModalOpen] = React.useState(false)
  const [homeModalOpen, setHomeModalOpen] = React.useState(false)

  return (
    <Layout>
      <Head>
        <title>Videos</title>
        <meta
          name="description"
          content="Check out our free, animated videos to learn everything you need to know to manage your finances!"
        />
      </Head>
      <div className="videos content">
        <div className="outer-container">
          <div className="inner-container">
            <p className="header mb30">The Essentials</p>

            <div className="row">
              <div className="icon-container">
                <a
                  className="icon-link"
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.youtube.com/watch?v=ku52Pb7fFT8&list=PLvQzIHSy2yPQiFilnlX8YfhI8O7GWsjln"
                >
                  <img alt="icon" className="icon" src={BankAccount.src} />
                  <p className="icon-title">Bank Accounts</p>
                </a>
              </div>

              <div className="icon-container">
                <a
                  className="icon-link"
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.youtube.com/watch?v=0ddgrHehprk&list=PLvQzIHSy2yPThT5GHAJ6Ic7w0bqtr96bN"
                >
                  <img alt="icon" className="icon" src={CreditCard.src} />
                  <p className="icon-title">Credit Cards</p>
                </a>
              </div>

              <div className="icon-container">
                <a
                  className="icon-link"
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.youtube.com/watch?v=x7msE3tx8QI&list=PLvQzIHSy2yPQhwivqy-HroilZnHY0WNy8"
                >
                  <img alt="icon" className="icon" src={Investing.src} />
                  <p className="icon-title">Investing</p>
                </a>
              </div>
            </div>

            <div className="row">
              <div className="icon-container">
                <a
                  className="icon-link"
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.youtube.com/watch?v=Z2r_apNMTeM&list=PLvQzIHSy2yPRPayzC8KzKnJLRJGtbyLZy"
                >
                  <img alt="icon" className="icon" src={Taxes.src} />
                  <p className="icon-title">Taxes</p>
                </a>
              </div>

              <div className="icon-container">
                <a
                  className="icon-link"
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.youtube.com/watch?v=fuiiJuB7tJs&list=PLvQzIHSy2yPRMzZy01DH2aj7EswkXsJ8C"
                >
                  <img alt="icon" className="icon" src={Loans.src} />
                  <p className="icon-title">Loans</p>
                </a>
              </div>

              <div className="icon-container">
                <a
                  className="icon-link"
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.youtube.com/watch?v=UGetd8kpxfQ&list=PLvQzIHSy2yPT7MdAQMfkLMBhsKysHcpoZ"
                >
                  <img alt="icon" className="icon" src={SpendingPlans.src} />
                  <p className="icon-title">Spending Plans</p>
                </a>
              </div>
            </div>

            <p id="insurance" className="header mb30">
              The Rest
            </p>

            <div id="housing" className="row">
              <div className="icon-container">
                <button
                  type="button"
                  onClick={() => setInsuranceModalOpen(true)}
                  className="icon-link"
                >
                  <img alt="icon" className="icon" src={Insurance.src} />
                  <p className="icon-title">Insurance</p>
                </button>
              </div>

              <div className="icon-container">
                <a
                  className="icon-link"
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.youtube.com/watch?v=_Jf-gcOzQEo&list=PLvQzIHSy2yPTBixoSdnZPCVwhyvy9FsiO"
                >
                  <img alt="icon" className="icon" src={Education.src} />
                  <p className="icon-title">Education</p>
                </a>
              </div>

              <div className="icon-container">
                <a
                  className="icon-link"
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.youtube.com/watch?v=ApHRfYA1A-Y&list=PLvQzIHSy2yPTxXgtxf9G0fC59H69pfIR8"
                >
                  <img alt="icon" className="icon" src={Retirement.src} />
                  <p className="icon-title">Retirement</p>
                </a>
              </div>
            </div>

            <div className="row">
              <div className="icon-container">
                <a
                  className="icon-link"
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.youtube.com/watch?v=Wh44hyYLnS4&list=PLvQzIHSy2yPRgb90W-XwyjXMaiQhsD550"
                >
                  <img alt="icon" className="icon" src={Debt.src} />
                  <p className="icon-title">Debt Management</p>
                </a>
              </div>

              <div className="icon-container">
                <button
                  type="button"
                  className="icon-link"
                  onClick={() => setHomeModalOpen(true)}
                >
                  <img alt="icon" className="icon" src={Homes.src} />
                  <p className="icon-title">Housing</p>
                </button>
              </div>

              <div className="icon-container">
                <a
                  className="icon-link"
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.youtube.com/watch?v=ffuBeqaIGgY&list=PLvQzIHSy2yPTMQuSVWhidS-yDVVJS8SDI"
                >
                  <img alt="icon" className="icon" src={Cars.src} />
                  <p className="icon-title">Cars</p>
                </a>
              </div>
            </div>

            <div className="row">
              <div className="icon-container">
                <a
                  className="icon-link"
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.youtube.com/watch?v=qBDCnKfExw4"
                >
                  <img alt="icon" className="icon" src={IdTheft.src} />
                  <p className="icon-title">Identity Theft</p>
                </a>
              </div>

              <div className="icon-container">
                <a
                  className="icon-link"
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.youtube.com/watch?v=dbArvg5wvB0&list=PLvQzIHSy2yPTZIPS48g2XtPTM1QY2u-KH"
                >
                  <img alt="icon" className="icon" src={Relationships.src} />
                  <p className="icon-title">Relationships</p>
                </a>
              </div>

              <div className="icon-container">
                <a
                  className="icon-link"
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.youtube.com/watch?v=cMoaGEpffds"
                >
                  <img alt="icon" className="icon" src={EstatePlan.src} />
                  <p className="icon-title">Estate Planning</p>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Modals */}
        {/* Homeowners */}

        <Modal
          isOpen={homeModalOpen}
          ariaHideApp={false}
          onRequestClose={() => setHomeModalOpen(false)}
          className="content"
          // @ts-expect-error
          style={customStyles}
        >
          <div className="modal">
            <div className="modal-icon-container">
              <div className="icon-container">
                <a
                  className="icon-link"
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.youtube.com/watch?v=7ow49RAUwXE&list=PLvQzIHSy2yPR8e38-qK6Bm15DubmRDDL2"
                >
                  <img alt="icon" className="icon" src={Houses.src} />
                  <p className="icon-title">Buying</p>
                </a>
              </div>

              <div className="icon-container">
                <a
                  className="icon-link"
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.youtube.com/watch?v=36wIsi1deLU&list=PLvQzIHSy2yPS7jdHX76gvgOJGfFxtvye_"
                >
                  <img alt="icon" className="icon" src={Apartment.src} />
                  <p className="icon-title">Renting</p>
                </a>
              </div>
            </div>
          </div>
        </Modal>

        {/* Insurance */}
        <Modal
          isOpen={insuranceModalOpen}
          ariaHideApp={false}
          onRequestClose={() => setInsuranceModalOpen(false)}
          className="content"
          // @ts-expect-error
          style={customStyles}
        >
          <div className="modal">
            <div className="modal-icon-container">
              <div className="icon-container">
                <a
                  className="icon-link"
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.youtube.com/watch?v=Gx0kHOibwHA&list=PLvQzIHSy2yPQxFSaQknyy4V4OH_u0yib0"
                >
                  <img alt="icon" className="icon" src={HealthInsurance.src} />
                  <p className="icon-title">Health</p>
                </a>
              </div>

              <div className="icon-container">
                <a
                  className="icon-link"
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.youtube.com/watch?v=669qsOnerUg&list=PLvQzIHSy2yPQMY4-_M02M7TyvV4DpNfME"
                >
                  <img alt="icon" className="icon" src={LtdInsurance.src} />
                  <p className="icon-title">LTD</p>
                </a>
              </div>

              <div className="icon-container">
                <a
                  className="icon-link"
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.youtube.com/watch?v=gxVm_HZtQew&list=PLvQzIHSy2yPSlIYAmva3fgM2OawPwI1es"
                >
                  <img alt="icon" className="icon" src={LifeInsurance.src} />
                  <p className="icon-title">Life</p>
                </a>
              </div>

              <div className="icon-container">
                <a
                  className="icon-link"
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.youtube.com/watch?v=ioLtDau8MVA&list=PLvQzIHSy2yPQ091n8LBNHWFWJ1_uzsj5F"
                >
                  <img alt="icon" className="icon" src={CarInsurance.src} />
                  <p className="icon-title">Car</p>
                </a>
              </div>

              <div className="icon-container">
                <a
                  className="icon-link"
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.youtube.com/watch?v=36wIsi1deLU&list=PLvQzIHSy2yPS7jdHX76gvgOJGfFxtvye_"
                >
                  <img alt="icon" className="icon" src={RentersInsurance.src} />
                  <p className="icon-title">Renters</p>
                </a>
              </div>

              <div className="icon-container">
                <a
                  className="icon-link"
                  target="_blank"
                  rel="noreferrer"
                  href="https://www.youtube.com/watch?v=u4mp79V2kRc&list=PLvQzIHSy2yPRCnGBvR7pOe_fSL-tDj9_B"
                >
                  <img alt="icon" className="icon" src={HomeInsurance.src} />
                  <p className="icon-title">Homeowners</p>
                </a>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </Layout>
  )
}

export default Videos
